import { Button, Card, Form, List, Skeleton, Space, Spin } from 'antd'
import { cleanUpEditedTask } from '../CreateTask/helpers'
import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { connect } from 'react-redux'
import Job from './Job'
import './index.scss'
import TaskForm from '../CreateTask/Forms/TaskForm'
import moment from 'moment'

function Jobs ({ task, showConfig, plugins }) {

  const { uid } = task

  const [jobsListLength, setJobsListLength] = useState(5)
  const [taskForm] = Form.useForm()
  const [creatingJob, setCreatingJob] = useState(false)
  const orchestrator = plugins['weaver-orchestrator']

  const { data, isLoading } = useQuery({
    queryKey: [`pipelines.tasks.${uid}.jobs`],
    queryFn: () => orchestrator.getJobs({ scheduleUid: uid }),
    refetchInterval: 3000
  })

  const loadMore = () => {
    return (
      <div className="jobs-container">
        <Button
          onClick={() => {
            jobsListLength < JSON.parse(data).length
            ?
            setJobsListLength(jobsListLength + 5)
            :
            setJobsListLength(JSON.parse(data).length)
          }}
        >
          Show more
        </Button>
      </div>
    )
  }

  const loading = () => {
    return (
      <Space
        size="middle"
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
          padding: '10px'
        }}
      >
        <div>Fetching jobs...</div>
        <Spin />
      </Space>
    )
  }

  const renderItems = () => {
    if (JSON.parse(data).length > 0) {
      return (
        _.slice(_.orderBy(JSON.parse(data), ['started'],['desc']), 0, jobsListLength).map((job) =>
          <List.Item key={job.uid}>
            <Skeleton
              active
              title={false}
              loading={isLoading}
            >
              <Job orchestrator={orchestrator} job={job}/>
            </Skeleton>
          </List.Item>
        )
      )
    } else {
      return (
        <Space
          size="middle"
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            padding: '10px'
          }}
        >
          No Jobs
        </Space>
      )
    }
  }

  const renderLoadMore = () => JSON.parse(data).length > jobsListLength ? loadMore() : false

  const runNow = async () => {
    const dirty = taskForm.getFieldsValue()
    const cleaned = await cleanUpEditedTask(uid, dirty)

    try {
      if (!_.isEqual(task.config, cleaned.config)) {
        await orchestrator.updateConfiguration(cleaned)
      }
      await orchestrator.addCron({
        scheduleUid: uid,
        runOnce: true,
        firstRun: moment().utc().valueOf()/1000,
        cron: {}
      })
    } catch (err) {
      console.error(err)
    }
  }

  const renderConfig = () => {
    return (
      <Card style={{ width: '100%' }}>
        <Card.Meta
          description={
            <>
              <TaskForm
                form={taskForm}
                taskId={uid}
                onlyConfig={true}
              />
              <Button
                disabled={creatingJob}
                type="primary"
                style={{ width: '100%'}}
                onClick={async () => {
                  setCreatingJob(true);
                  await runNow();
                  setCreatingJob(false);
                }}
              >
                { creatingJob ? 'Creating Job...' : 'Run Now' }
              </Button>
            </>
          }
        />
      </Card>
    )
  }

  // TODO: Handle pagination when it becomes available.
  return (
    <List
      className='jobs-list'
      bordered={false}
      itemLayout="horizontal"
      loadMore={isLoading ? false : renderLoadMore()}
    >
      { showConfig ? renderConfig() : null}
      { isLoading ? loading() : renderItems() }
    </List>
  )
}

const mapStateToProps = ({ explore: { plugins }}) => ({ plugins })
export default connect(mapStateToProps)(Jobs)
